import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ReferenceService } from '../../../services/reference/reference.service';
import * as actions from './reference.actions';

@Injectable()
export class ReferenceEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly service: ReferenceService,
  ) {}

  getCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getCountries),
      switchMap(({}) =>
        this.service.getCountries().pipe(
          map((countries) => {
            return actions.getCountriesSuccess({ countries });
          }),
          catchError((error: any) => of(actions.getCountriesFailure(error))),
        ),
      ),
    ),
  );

  getIndustries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(actions.getIndustries),
      switchMap(({}) =>
        this.service.getIndustries().pipe(
          map((industries) => {
            return actions.getIndustriesSuccess({ industries });
          }),
          catchError((error: any) => of(actions.getIndustriesFailure(error))),
        ),
      ),
    ),
  );
}
